import { styled } from 'styled-components';

export const SearchContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    width: 100%;
    background: transparent;
    max-width: 750px;
`;

export const SearchInput = styled.input`
    width: 100%;
    padding: 8px 16px 8px 45px;
    border: none;
    border-radius: 16px;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    line-height: 120%;
    outline: none;
    transition: all 0.2s ease;
    background: ${({ theme }) => theme?.colors?.theme?.contentBg};
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};

    &::-webkit-search-cancel-button {
        -webkit-appearance: none;
        appearance: none;
    }

    &::placeholder {
        color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    }

    &:focus {
        border: none;
        outline: none;
    }
`;

export const SearchIcon = styled.div`
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ theme }) => theme?.colors?.text?.muted};
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
`; 